/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Encrypt_PcInputs */

const en_pc_cmp_r_encrypt_pc = /** @type {(inputs: Pc_Cmp_R_Encrypt_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RC4 to AES-256, plus redaction and sanitizing`)
};

const zh_pc_cmp_r_encrypt_pc = /** @type {(inputs: Pc_Cmp_R_Encrypt_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RC4 至 AES-256，并支持涂黑与清理隐藏信息`)
};

/**
* | output |
* | --- |
* | "RC4 to AES-256, plus redaction and sanitizing" |
*
* @param {Pc_Cmp_R_Encrypt_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_encrypt_pc = /** @type {((inputs?: Pc_Cmp_R_Encrypt_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Encrypt_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_encrypt_pc(inputs)
	return zh_pc_cmp_r_encrypt_pc(inputs)
});
export { pc_cmp_r_encrypt_pc as "pc.cmp.r.encrypt.pc" }